import React from "react";
import { formatDate } from "../../../../utils";

export default class DateTextCell extends React.PureComponent {
    render() {
        return this.props.value ? formatDate(this.props.value) : "";
    }
}
